import React from 'react';
import { motion } from 'framer-motion';
import { partners } from '../../config/data';
import { useTranslation } from 'react-i18next';

const Sponsors: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="py-8">
      <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-10 text-center">{t('sections.partners_title', 'Nasi partnerzy')}</h2>
      <div className="flex flex-wrap justify-center gap-8 mt-4">
        {partners.map((sponsor, index) => (
          <motion.div 
            key={sponsor.name} 
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            whileHover={{ scale: 1.1 }}
          >
            <a href={sponsor.url_path} target="_blank" rel="noopener noreferrer">
              <img 
                src={`${process.env.PUBLIC_URL}${sponsor.img_path}`} 
                alt={sponsor.name} 
                className="max-w-[200px] max-h-[120px] object-contain"
              />
            </a>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Sponsors;
